<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
const QES_PREFIX = 'qestsp';
const TSP_PREFIX = 'wallidtsp';

const QES_PATH = '/QES/';
const TSP_PATH = '/wallet/';

export default {
  created() {
    let gtagId = '';
    if (window.location.host.includes('demo')) {
      localStorage.setItem('debug', 'iframe:error:*');
    } else {
      localStorage.setItem('debug', 'iframe:*');
    }
    if (
      window.session_id_tsp.startsWith(QES_PREFIX) ||
      window.location.host.includes('qes') ||
      window.IFRAME === 'QES'
    ) {
      // gtag qes flow id
      gtagId = 'G-ZL0YZSET4L';
      this.$router.push({ path: QES_PATH });
    } else if (window.session_id_tsp.startsWith(TSP_PREFIX)) {
      // gtag eth flow id
      gtagId = 'G-JQGES6VEYD';
      this.$router.push({ path: TSP_PATH });
    }
    // set the gtag in window
    window.GA_ID = gtagId;

    // eslint-disable-next-line no-undef
    gtag('config', gtagId, {
      send_page_view: false,
      cookie_flags: 'max-age=7200;secure;samesite=none',
      linker: {
        domains: [
          'demo-qes.tsp.wallid.io',
          'qes.tsp.wallid.io',
          'dev.wallid.io',
          'wallid.io',
          'localhost:8080',
          'localhost:8000',
        ],
      },
    });
  },
};
</script>

<style></style>
